import {
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import { useEditorState } from '@tiptap/react'
import clsx from 'clsx'
import { editorDropdownItem, editorDropdownItemActive } from './EditorInput.css'
import { SplitButtonDropdown } from './SplitButtonDropdown'

export const AlignmentDropdown = ({ editor }: { editor: Editor }) => {
  const editorState = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isLeft: editor.isActive({ textAlign: 'left' }),
      isCenter: editor.isActive({ textAlign: 'center' }),
      isRight: editor.isActive({ textAlign: 'right' }),
      isJustify: editor.isActive({ textAlign: 'justify' })
    })
  })

  const activeIcon = editorState.isCenter
    ? faAlignCenter
    : editorState.isRight
      ? faAlignRight
      : editorState.isJustify
        ? faAlignJustify
        : faAlignLeft

  return (
    <SplitButtonDropdown
      isActive={
        editorState.isCenter || editorState.isRight || editorState.isJustify
      }
      icon={<FontAwesomeIcon icon={activeIcon} />}
      onMainClick={() => editor.chain().focus().setTextAlign('left').run()}
    >
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isLeft && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().setTextAlign('left').run()}
      >
        <FontAwesomeIcon icon={faAlignLeft} />
        Gauche
      </button>
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isCenter && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().setTextAlign('center').run()}
      >
        <FontAwesomeIcon icon={faAlignCenter} />
        Centré
      </button>
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isRight && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().setTextAlign('right').run()}
      >
        <FontAwesomeIcon icon={faAlignRight} />
        Droite
      </button>
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isJustify && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().setTextAlign('justify').run()}
      >
        <FontAwesomeIcon icon={faAlignJustify} />
        Justifié
      </button>
    </SplitButtonDropdown>
  )
}
